import React from "react";
import { useEffect } from "react";
import "../../App.css";
import about from "../../img/about-picture.png";

function About() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div id="aboutme" className="about-section">
      <section className="about-header flex flex-col bg-primary justify-center items-center gap-x-32 gap-y-12 px-5 py-12 md:flex-row md:px-10 lg:px-20">
        <section className="about-header-left">
          {/* <p className="text-white text-subhead italic">Hi there!</p> */}
          <h1 className="text-white text-header">
            A pianist wannabe, avid gamer, & UX designer.
          </h1>
        </section>
        <section className="about-header-right">
          <img class="about-pict rounded-3xl" src={about} alt="about"></img>
        </section>
      </section>

      <section className="about-more flex flex-col px-5 py-12 justify-center items-center gap-y-4 md:px-10 lg:px-20 lg:justify-start lg:items-start">
        <p className="about-text text-body">
          Raised and based on Jakarta, Indonesia. I’ve been working in tech
          industry as a business founder and designer for 3 years after
          graduated from mining engineering major. And I completed MBA program
          from Institut Teknologi Bandung to sharpen my business and management
          skill.{" "}
        </p>
        <p className="about-text text-body">
          I’ve always amazed how technology could change people’s behavior and
          become a great solution to many specific problems. No matter the size
          of the solution, it could be a thing that makes our life easier.{" "}
        </p>
        <p className="about-text text-body">
          Previously worked across diverse startup companies from F&B to fashion
          to software and hard-tech. Even though the instability and uncertainty
          of startup work-environement, I found my purpose and meaning in my
          work as a product maker. Because, I'm sure the uncertainty is the only
          certainty whenever we want to make something great and deliver it to
          society.{" "}
        </p>
        <p className="about-text text-body">
          And you might questioning how I develop my skill in design and code?
          To be honest, its all self-taught. I believe everyone has the ability
          to push the boundaries if we are willing to put the works.
        </p>
      </section>
    </div>
  );
}

export default About;
